function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import { WDHImage } from '@demant/wdh';
import { TweenLite } from 'gsap/all';
import { triggerEvent } from '../../../../../../wdh-foundation/wdh';
function offset(el) {
  var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return {
    top: rect.top + scrollTop,
    left: rect.left + scrollLeft
  };
}
var AsTabSpot = function AsTabSpot(_ref) {
  var settings = _ref.settings;
  var spotList = settings.elements || [];
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    isActive = _useState2[0],
    setActive = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    currentScrollTo = _useState4[0],
    setCurrentScrollTo = _useState4[1];
  var activeEl = useRef(null);
  var isDesktop = window.matchMedia('(min-width:768px)').matches;
  useEffect(function () {
    triggerEvent('link-embed-code-detected');
  });
  var scrollSelectedIntoView = function scrollSelectedIntoView() {
    var header = document.querySelector('.header-mobile-top.outer-container');
    if (header) {
      if (isActive !== null) {
        var selectedItem = activeEl.current;
        var offsetTop = offset(selectedItem).top - header.offsetHeight;
        var duration = offsetTop === currentScrollTo ? 0 : 0.6;
        setCurrentScrollTo(offsetTop);
        TweenLite.to(window, duration, {
          delay: 0,
          scrollTo: {
            y: offsetTop
          }
        });
      } else {
        TweenLite.to(window, 0, {
          delay: 0,
          scrollTo: {
            y: currentScrollTo
          }
        });
      }
    }
  };
  useEffect(function () {
    if (!isDesktop) {
      scrollSelectedIntoView();
    }
  }, [isActive]);
  var handleClick = function handleClick(index) {
    if (!isDesktop && isActive === index) {
      setActive(null);
    } else {
      setActive(index);
    }
  };
  var indexKey = 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: "image-spot-elements"
  }, spotList.map(function (item, index) {
    if (item.header !== null) {
      return /*#__PURE__*/React.createElement("li", {
        className: "image-spot-element ".concat(isActive === index ? 'active' : ''),
        key: indexKey++,
        ref: isActive === index ? activeEl : null
      }, /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          return handleClick(index);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "scLooseFrameZone",
        sc_item: item.sitecoreItem || ''
      }, /*#__PURE__*/React.createElement("span", {
        className: "scChromeData"
      }, item.sitecoreChromeData || ''), /*#__PURE__*/React.createElement("div", {
        className: "image-spot-element-inner-container"
      }, item.image && /*#__PURE__*/React.createElement("div", {
        className: "image-spot-element-image"
      }, /*#__PURE__*/React.createElement(WDHImage, {
        image: item.image.image
      })), item.header && /*#__PURE__*/React.createElement("div", {
        className: "image-spot-element-header",
        dangerouslySetInnerHTML: {
          __html: item.header
        }
      })))), !isDesktop && item.text && isActive === index && /*#__PURE__*/React.createElement("div", {
        className: "image-spot-element-text",
        dangerouslySetInnerHTML: {
          __html: item.text
        }
      }));
    }
    return null;
  })), spotList.map(function (item, index) {
    return isActive === index && isDesktop ? /*#__PURE__*/React.createElement("div", {
      className: "image-spot-element-text",
      dangerouslySetInnerHTML: {
        __html: item.text
      }
    }) : null;
  }));
};
export default AsTabSpot;